module.exports = __webpack_public_path__ + "img/window_2.de9ebcaa.png";